import ScrollMagic from 'scrollmagic';

$(() => {

    const controller = new ScrollMagic.Controller();

    new ScrollMagic.Scene({
        triggerElement: '.l-page__header',
        offset: 50,
        reverse: false
    })
    .setClassToggle('.l-page__header .js-animate', 'js-animate-loaded')
    .addTo(controller);

    new ScrollMagic.Scene({
        triggerElement: '.l-page__risks-system',
        triggerHook: 0.95,
        reverse: false
    })
    .setClassToggle('.l-page__risks-system .js-animate', 'js-animate-loaded')
    .addTo(controller);

    new ScrollMagic.Scene({
        triggerElement: '.l-page__risks-filter',
        triggerHook: 0.95,
        reverse: false
    })
    .setClassToggle('.l-page__risks-filter .js-animate', 'js-animate-loaded')
    .addTo(controller);

    new ScrollMagic.Scene({
        triggerElement: '.l-page__risks-analyze',
        triggerHook: 0.95,
        reverse: false
    })
    .setClassToggle('.l-page__risks-analyze .js-animate', 'js-animate-loaded')
    .addTo(controller);

    new ScrollMagic.Scene({
        triggerElement: '.l-page__risks-other-technologies',
        triggerHook: 0.8,
        reverse: false
    })
    .setClassToggle('.l-page__risks-other-technologies .js-animate', 'js-animate-loaded')
    .addTo(controller);

    new ScrollMagic.Scene({
        triggerElement: '.l-page__get-now',
        triggerHook: 0.8,
        reverse: false
    })
    .setClassToggle('.l-page__get-now .js-animate', 'js-animate-loaded')
    .addTo(controller);


});



// WEBPACK FOOTER //
// ./app/scripts/pages/technologies/risks.js